export default [
    {
        id: 1,
        name: 'Alexa Dolgove',
        thumb: 'https://picsum.photos/150/150?image=1027',
        status: 'away',
        mood: 'Client',
        lastMessage: 'Client - 257 Gold Street',
        unreadMessage: '',
        lastMessageTime: '20 min ago',
        recent: false
    }, {
        id: 2,
        name: 'Domnic Brown',
        thumb: 'http://i.pravatar.cc/150?img=17',
        status: 'online',
        mood: 'Client',
        lastMessage: 'Client',
        unreadMessage: '4',
        lastMessageTime: 'Yesterday',
        recent: true
    }, {
        id: 3,
        name: 'Domnic Harris',
        thumb: 'http://i.pravatar.cc/150?img=18',
        status: 'offline',
        mood: 'Client',
        lastMessage: 'Client ',
        unreadMessage: '',
        lastMessageTime: '20/11/17',
        recent: false
    }, {
        id: 4,
        name: 'Garry Sobars',
        thumb: 'http://i.pravatar.cc/150?img=11',
        status: 'away',
        mood: 'Broker',
        lastMessage: 'Broker',
        unreadMessage: '3',
        lastMessageTime: 'Yesterday',
        recent: true
    }, {
        id: 5,
        name: 'Jeson Born',
        thumb: 'http://i.pravatar.cc/150?img=51',
        status: 'away',
        mood: 'Transaction Manager ',
        lastMessage: 'Transaction Manager',
        unreadMessage: '',
        lastMessageTime: 'Monday',
        recent: true
    }, {
        id: 6,
        name: 'Jimmy Jo',
        thumb: 'http://i.pravatar.cc/150?img=58',
        status: 'online',
        mood: 'Client',
        lastMessage: 'Client',
        unreadMessage: '',
        lastMessageTime: 'Friday',
        recent: false
    }, {
        id: 7,
        name: 'John Smith',
        thumb: 'http://i.pravatar.cc/150?img=12',
        status: 'away',
        mood: 'Client ',
        lastMessage: 'Client',
        unreadMessage: '',
        lastMessageTime: 'Tuesday',
        recent: true
    }, {
        id: 8,
        name: 'Kadir M',
        thumb: 'http://i.pravatar.cc/150?img=56',
        status: 'online',
        mood: 'Broker',
        lastMessage: 'Broker ',
        unreadMessage: '5',
        lastMessageTime: 'Monday',
        recent: false
    }, {
        id: 9,
        name: 'Jimmy Jon',
        thumb: 'http://i.pravatar.cc/150?img=59',
        status: 'offline',
        mood: 'Client ',
        lastMessage: 'Client ',
        unreadMessage: '',
        lastMessageTime: '30 Min ago',
        recent: false
    }, {
        id: 10,
        name: 'Stella Johnson',
        thumb: 'http://i.pravatar.cc/150?img=5',
        status: 'offline',
        mood: 'Escrow Officer',
        lastMessage: 'Escrow Officer',
        unreadMessage: '',
        lastMessageTime: 'Yesterday',
        recent: false
    }, {
        id: 11,
        name: 'Luna Lovegood',
        thumb: 'http://i.pravatar.cc/150?img=40',
        status: 'online',
        mood: 'Title Company',
        lastMessage: 'Title Company',
        unreadMessage: '2',
        lastMessageTime: 'Monday',
        recent: false
    }
]


// WEBPACK FOOTER //
// ./app/routes/chatPanel/data/chatUsers.js